import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './Kernteamportal.css';
import { kernteam_password, portal_url } from './App';
import KernteamNavbar from './navbar/KernteamNavbar';

function Kernteamportal() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(Cookies.get('KTisAuthenticated') === 'true');

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === `${kernteam_password}`) {
      setIsAuthenticated(true);
      Cookies.set('KTisAuthenticated', 'true', { expires: 10 }); // Login 10 Tage speichern
    } else {
      alert('Falsches Passwort');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="login-screen">
        <form onSubmit={handlePasswordSubmit}>
          <label>
            Passwort:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button type="submit">Einloggen</button>
        </form>
      </div>
    );
  }

  return (
    <>
      <KernteamNavbar />
      <div className="kernteamportal-wrapper">
        <div className="area-container">

          <div className="area-card arbeit" onClick={() => navigate("/arbeit", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Arbeit</h2>
              <p>
                Verwalte Jobs, teile Aufgaben zu, bearbeite bestehende Tätigkeiten
                oder füge neue hinzu.
              </p>
              <span className="material-symbols-outlined area-icon">business_center</span>
            </div>
          </div>

          <div className="area-card logistik" onClick={() => navigate("/logistik", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Logistik</h2>
              <p>
                Schichtplan verwalten, Fahrten planen und Inventar
                pflegen. Die Inventarliste ist im Portal sichtbar.
              </p>
              <span className="material-symbols-outlined area-icon">local_shipping</span>
            </div>
          </div>

          <div className="area-card kinder" onClick={() => navigate("/kinder", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Kinder Verwalten</h2>
              <p>
                Kinder hinzufügen, bearbeiten und Spezialwünsche verwalten.
              </p>
              <span className="material-symbols-outlined area-icon">emoji_people</span>
            </div>
          </div>

          <div className="area-card parlament" onClick={() => navigate("/parlament/ausschuesse", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Parlament</h2>
              <p>
                Ausschüsse anlegen, umbenennen und löschen. Die Änderungen
                sind direkt im Stormini-Portal sichtbar.
              </p>
              <span className="material-symbols-outlined area-icon">account_balance</span>
            </div>
          </div>

          <div className="area-card freizeit" onClick={() => navigate("/freizeit", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Freizeit</h2>
              <p>
                Hier steuerst du das Freizeitprogramm: Angebote eintragen, bearbeiten
                und auf der Lagerkarte positionieren.
              </p>
              <span className="material-symbols-outlined area-icon">sports_volleyball</span>
            </div>
          </div>

          <div className="area-card listen" onClick={() => navigate("/listen", { state: { fromPortal: true } })}>
            <div className="area-content">
              <h2>Listen</h2>
              <p>
                Alle zentralen Listen im Blick: Steuer, Wahl, Dienste und die Anträge auf
                Selbstständigkeit.
              </p>
              <span className="material-symbols-outlined area-icon">list_alt</span>
            </div>
          </div>

        </div>
        <div className="footer-link">
  <a href={portal_url} target="_blank" rel="noopener noreferrer">
    Zum Stormini-Portal
  </a>
</div>

      </div>
    </>
  );
}

export default Kernteamportal;
